import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Modal } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import { editMatriculado } from 'redux/matriculadosSlice';
import ButtonAccept from 'utils/buttons/ButtonAccept';
import ButtonClose from 'utils/buttons/ButtonClose';
import PropTypes from 'prop-types';
import ModalButtonsContainer from 'sites/common/ModalButtonsContainer';

const DisableMatriculadoModal = ({ user, setShow }) => {
  const dispatch = useDispatch();

  const handleClose = () => setShow(false);
  const handleDisable = async () => {
    dispatch(editMatriculado(user.id, { bypassed: false }));
    handleClose();
  };

  return (
    <>
      <Modal
        keyboard={true}
        show={true}
        onHide={handleClose}
        backdrop="static"
        centered
      >
        <Modal.Header closeButton>
          <FontAwesomeIcon
            icon="fa-pause"
            title="Deshabilitar"
            size="1x"
            style={{ marginRight: 8, color: '#02a8b5' }}
          />

          <Modal.Title>Deshabilitar login directo</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <div className="mb-4">
            El usuario{' '}
            <b>
              {user.firstName} {user.lastName}
            </b>{' '}
            ya no podrá ingresar con login directo.
            <br />
            <br />
            ¿Está seguro de confirmar esta acción?
          </div>

          <ModalButtonsContainer>
            <ButtonClose
              text="Cancelar"
              funcion={handleClose}
              variant="secondary"
            />

            <ButtonAccept text="Confirmar" funcion={handleDisable} />
          </ModalButtonsContainer>
        </Modal.Body>
      </Modal>
    </>
  );
};

DisableMatriculadoModal.propTypes = {
  user: PropTypes.object.isRequired,
  setShow: PropTypes.func.isRequired
};

export default DisableMatriculadoModal;
